module.exports = __webpack_public_path__ + "static/media/hearticon.a5df8ea5.svg";